module.exports = __webpack_public_path__ + "img/Encoding.36ecb137.png";